import { createAction, createReducer } from '@reduxjs/toolkit';
import { Tracking, TrackingsState, TrackingType } from './trackingsTypes';
import _ from 'lodash';

const initialState: TrackingsState = {
  trackings: [],
};

/** Update trackings table (all at once) */
export const updateTrackings = createAction<Tracking[]>('UPDATE_TRACKINGS');

/** Add single tracking */
export const addTracking = createAction<Tracking>('ADD_TRACKING');

/** Remove existing tracking by MS id. */
export const removeTracking = createAction<{ type: TrackingType; id: number }>('REMOVE_TRACKING');

/** Update single tracking */
export const updateTracking = createAction<Tracking>('UPDATE_TRACKING');

export const trackingsReducer = createReducer(initialState, builder => {
  builder.addCase(updateTrackings, (state, action) => {
    state.trackings = action.payload;
  });
  builder.addCase(addTracking, (state, action) => {
    state.trackings.push(action.payload);
  });
  builder.addCase(updateTracking, (state, action) => {
    const index = _.findIndex(
      state.trackings,
      item => item.entityType === action.payload.entityType && item.entityId === action.payload.entityId,
    );
    if (index !== -1) {
      const updated = _.cloneDeep(state.trackings);
      updated[index] = action.payload;
      state.trackings = updated;
    }
  });
  builder.addCase(removeTracking, (state, action) => {
    const index = _.findIndex(
      state.trackings,
      item => item.entityType === action.payload.type && item.entityId === action.payload.id,
    );
    if (index !== -1) {
      state.trackings.splice(index, 1);
    }
  });
});
